import styled from "styled-components";
import { pixels } from "../../../constants/pixels";

const Container = styled.div`
  position: absolute;
  top: ${({ allPrint }) => (allPrint ? "30%" : "15%")};
  right: ${({ allPrint }) => (allPrint ? "12%" : "5%")};
`;

const Box = styled.div`
  color: ${({ color }) => color};
  border: 1px solid ${({ color }) => color};
  padding: 10px;
  border-radius: 3px;
  font-weight: 700;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 10px;
  @media screen and (min-width: 900px) {
    font-size: 14px;
  }
`;

const Item = styled.div``;

const Time = styled.div`
  background: ${({ color }) => color};
  color: white;
  padding: 7px;
  margin-left: 10px;
  border-radius: 5px;
  font-weight: 900;
`;

const Timing = ({ trait, allPrint, width }) => {
  const heightBool = trait.h / pixels / 12 <= 10;
  let timing = heightBool ? 25 : 45;

  if (trait.windows === 1) {
    timing = heightBool ? 45 : 60;
  }
  if (trait.doors / pixels > 0) {
    timing = heightBool ? 35 : 45;
  }
  if (trait.frenchDoor === "left" || trait.frenchDoor === "right") {
    timing = heightBool ? 60 : 75;
  }

  if (trait.frenchDoor === "middle") {
    timing = heightBool ? 15 : 25;
  }

  if (trait.windows > 1 && heightBool) {
    timing = 90;
  }

  if (trait.windows && trait.doors / pixels && heightBool) {
    timing = 90;
  }

  if (trait.windows && trait.frenchDoor) {
    timing = heightBool ? 75 : 90;
  }

  return (
    <Container allPrint={typeof allPrint !== "undefined"}>
      <Box color={"blue"} size={width}>
        <Item>Ideal time:</Item>
        <Time color={"blue"}>{timing} MIN</Time>
      </Box>
      <Box color={"green"}>
        <Item>Actual:</Item>
      </Box>
    </Container>
  );
};

export default Timing;
